export default {
    baseApi:process.env.VUE_APP_URL||(window.location.protocol + "//" + window.location.host),
    tokenKey:process.env.VUE_APP_TOKEN ||'stargood_token',
    refreshTokenKey:process.env.VUE_APP_RE_TOKEN ||'stargood_refresh_token',
    tokenExpires:process.env.VITE_TOKEN_EXPIRES || 'token_expires',
}
